import type { RouteRecordRaw } from "vue-router";

export const profileRoutes: RouteRecordRaw[] = [
  {
    path: "/profile",
    component: () => import("../ProfileLayout.vue"),
    meta: {
      requiresAuth: true,
    },
    redirect: { name: "profile-general" },
    children: [
      {
        path: "general",
        name: "profile-general",
        component: () => import("./general.vue"),
        meta: {
          title: "profile.general.title",
          requiresAuth: true,
        },
      },
      {
        path: "account",
        name: "profile-account",
        component: () => import("./account.vue"),
        meta: {
          title: "profile.account.title",
          requiresAuth: true,
        },
      },
      {
        path: "disconnect_oauth",
        name: "profile-disconnect-oauth",
        component: () => import("./disconnect_oauth.vue"),
        meta: {
          title: "profile.disconnectOauth.title",
          requiresAuth: true,
        },
      },
      {
        path: "privacy",
        name: "profile-privacy",
        component: () => import("./privacy.vue"),
        meta: {
          title: "profile.privacy.title",
          requiresAuth: true,
        },
      },
      {
        path: "email_settings",
        name: "profile-email-settings",
        component: () => import("./email_settings.vue"),
        meta: {
          title: "profile.emailSettings.title",
          requiresAuth: true,
        },
      },
      {
        path: "licenses",
        name: "profile-licenses",
        component: () => import("./licenses.vue"),
        meta: {
          title: "profile.licenses.title",
          requiresAuth: true,
        },
      },
      {
        path: "export",
        name: "profile-export",
        component: () => import("./export.vue"),
        meta: {
          title: "profile.export.title",
          requiresAuth: true,
        },
      },
      {
        path: "authorized_applications",
        name: "profile-authorized-applications",
        component: () => import("./authorized_applications.vue"),
        meta: {
          title: "profile.authorizedApplications.title",
          requiresAuth: true,
        },
      },
    ],
  },
];
